module.exports = {
      id: "24adab00ff5d5aa36e4118a997cc262cbathroomEquipment-corner-bathtub.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#24adab00ff5d5aa36e4118a997cc262cbathroomEquipment-corner-bathtub.svg",
      toString: function () {
        return this.url;
      }
    }